import { Clock } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface StalenessAlertProps {
  status?: "active" | "warning" | "stale" | "terminal";
  daysSinceActivity?: number;
}

export function StalenessAlert({
  status,
  daysSinceActivity = 0,
}: StalenessAlertProps) {
  if (status === "terminal" || status === "active" || daysSinceActivity === 0) {
    return null;
  }

  const isStale = status === "stale";
  const days = daysSinceActivity;
  const dayLabel = days === 1 ? "día" : "días";

  return (
    <Alert
      variant="default"
      className={
        isStale
          ? "mt-3 border-orange-300 bg-orange-50 text-orange-800 w-full"
          : "mt-3 border-yellow-300 bg-yellow-50 text-yellow-800 w-full"
      }
    >
      <Clock className="h-4 w-4" />
      <AlertTitle className="text-sm font-medium">
        {isStale ? "Solicitud inactiva" : "Solicitud con poca actividad"}
      </AlertTitle>
      <AlertDescription className="text-xs">
        {isStale
          ? `Sin actividad durante ${days} ${dayLabel}. Considera avanzar con el proceso de compra.`
          : `Sin novedades durante ${days} ${dayLabel}.`}
      </AlertDescription>
    </Alert>
  );
}
